import { isLoggedGuard } from './middlewares/is.logged.guard';
import { isNotLoggedGuard } from './middlewares/is.not.logged.guard';
import { DefaultComponent } from './layouts/default/default.component';
import { MonitoresComponent } from './views/monitores/monitores.component';
import { GuestComponent } from './layouts/guest/guest.component';
import { AdministracionComponent } from './views/administracion/administracion/administracion.component';
import { BeaconHomeComponent } from './spook/beacon/component/beacon-home/beacon-home.component';
import { LoginComponent } from './auth/components/login/login.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'monitors',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'monitors',
    component: DefaultComponent,
    canActivate: [isLoggedGuard],
    children: [     
      {
        path: ':monitorId',
        component: MonitoresComponent,
      },
    ],
  },
  {
    path: 'dashboard',
    component: DefaultComponent,
    canActivate: [isLoggedGuard],
    children: [
      {
        path: '',
        component: MonitoresComponent,
      },
    ],
  },  
  {
    path: 'sitrack',
    component: DefaultComponent,
    canActivate: [isLoggedGuard],
    children: [
      {
        path: '',
        component: AdministracionComponent,
      }
    ],
  },
  {
    path: 'spook',
    component: DefaultComponent,
    canActivate: [isLoggedGuard],
    children: [
      {
        path: '',
        component: BeaconHomeComponent
      }
    ]
  },
  {
    path: '',
    component: GuestComponent,
    pathMatch: 'full',
    canActivate: [isNotLoggedGuard],
    children: [
      {
        path: '',
        component: LoginComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
